import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  inProgress = false;
  error: string;

  constructor(private router: Router,
              private fb: FormBuilder,
              private auth: AuthService) { }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ['',  Validators.required],
      password: ['', Validators.required],
    });
  }

  submit(data) {
    this.inProgress = true;
    this.auth.login(data)
      .subscribe(() => {
        this.inProgress = false;
        this.router.navigate(['/']);
      }, err => {
        this.inProgress = false;
        this.error = err.error.message || '';
      });
  }

}



// WEBPACK FOOTER //
// ./client/app/components/login/login.component.ts